<template>
      <b-form class="container">
    <div class="box">

      <h2>{{ $t('parametros-de-analise') }}</h2><br><br>
      <label for="manipulatedVariableMapping">{{ $t('variavel-manipulada') }}</label><br>
      <select id="manipulatedVariableMapping" v-model="goalSeekModel.manipulatedVariableMapping">
        <option value="" selected>{{ $t('selecione-uma-variavel-manipulada') }}</option>
        <option v-for="(maneuverVariable, index) in maneuverVariables" :key="index"
          :value="maneuverVariable.mapping">
          {{maneuverVariable.name}}
        </option>
      </select><br><br>
      
      <label for="processVariableMapping">{{ $t('variavel-objetivo') }}</label><br>
      <select id="processVariableMapping" v-model="goalSeekModel.processVariableMapping">
        <option value="" selected>{{ $t('selecione-uma-variavel-objetivo') }}</option>
      <option v-for="(processVariable, index) in processVariables" :key="index"
        :value="processVariable.mapping">
        {{processVariable.name}}
      </option>
      </select>
      
    </div>

    <div class="box2">
        <h2>{{ $t('solver') }}</h2><br>
            <span>
                <label for="objective">Objetivo: </label>
                <input id="objective" v-model="goalSeekModel.objective" type="number" :placeholder="$t('variavel-objetivo')" /><br>    
            </span>
          

            <span>
                <label for="maxIteractions">{{ $t('maximo-de-iteracoes') }} </label>
                <input id="maxIteractions" v-model="goalSeekModel.maxIteractions" type="number" :placeholder="$t('valor-maximo')" /><br>          
            </span>

            <span>
                <label for="tolerance">{{ $t('tolerancia') }} </label>
                <input id="tolerance" v-model="goalSeekModel.tolerance" type="number" :placeholder="$t('ex-10')" /><br>
            </span>

            <span>
                <label for="initialValue">{{ $t('chute-inicial') }}</label>
                <input id="initialValue" v-model="goalSeekModel.initialValue" type="number" :placeholder="$t('chute-inicial-aproximado')" /><br>
            </span>

            <span>  
                <label for="secondaryValue">{{ $t('chute-secundario') }} </label>
                <input id="secondaryValue" disabled v-model="goalSeekModel.secondaryValue" type="number" placeholder="" /><br>  
            </span>
        
            <span>
                <input id="sucessiveSubstitution" @click="enableSecondaryValue()" v-model="checked" type="checkbox">
                <label for="sucessiveSubstitution">{{ $t('substituicao-sucessiva') }}</label>
            </span>
        
    </div>

    <div class="box3">
      <h2>{{ $t('status-0') }}</h2>
      <div id="msg" class="msg"></div>
      </div>

    <footer>
      <Loading2 class="loading" v-bind:caption="msgLoading" />
      <MessageBox 
        class='msgBox' 
        style="display: none;" 
        :header="$t('atention')" 
        v-bind:info="sucessSimulation.info" 
        v-bind:question="sucessSimulation.question" 
        v-bind:action="applyDiagram" 
      />

      <img
      id="closeModal"
      src="@/assets/sair.png"
      :title="$t('cancelar')"
      :alt="$t('cancelar')"
      @click="$bvModal.hide(nameModel)"
      />

      <img
          id="stopSimulatorImage"
          src="@/assets/stop.png"
          :title="$t('parar-simulacao')"
          :alt="$t('parar-simulacao')"
          @click="setStopSimulation.stopStimulation()"
        />

      <img
          id="simulate"
          src="@/assets/play.png"
          :title="$t('executar-simulacao')"
          :alt="$t('executar-simulacao')"
          @click="doGoalSeek()"
        />
    </footer>
  </b-form>
</template>

<script>
import axios from 'axios'
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import Loading2 from "@/components/template/Loading2";
import MessageBox from "@/components/template/MessageBox";

  export default {
        name: "GoalSeek",

        components: { Loading2, MessageBox },

        props: [ "table" , "tableResultGoal", "loadTableOutputGoal", "nameModel" ],

        inject: ['callCalculationSimulation', 'setStopSimulation', 'stateOfSimulation'],

        data() {
          return {
            sucessSimulation: {
                info: "",
                question: "",
              },
            msgLoading: "Simulando...",
            checked: true,
            showWait: false,
            maneuverVariables: [],
            processVariables: [],
            goalSeekModel: {
              table: [],
              tableFlowChart: [],
              manipulatedVariableMapping : "",
              processVariableMapping : "",
              objective : 0,
              maxIteractions : 10,
              tolerance : 10,
              initialValue : 0,
              secondaryValue : 0,
              sucessiveSubstitution: true
            },
          }
        },

        methods: {
          //Carrega o modelo GoalSeek
          loadGoalSeekData: () => axios.get(`${urlMainAPI}/loadgoalseekdata`).then(d => d.data).catch(e => console.log('Falha na requisição da api', e)),

          // Envia o objetivo Para API
          async doGoalSeek() {
            this.showWait = true;
            this.goalSeekModel.sucessiveSubstitution = this.checked

            let goalSeek = {};
            
            this.msgLoading = this.$t('simulando')
            this.blockFilds(true)
            await this.loadGoalSeekData()
              .then(data => goalSeek = data)
              .catch(e => console.log("Falha na carga da do modelo GoalSeek. ", e));

            if (!localStorage.xml) {
              try {
                await axios.get(`${urlMainAPI}/loadactivesimulationscenario`)
                  .then(res => {
                    let xml = {}
                    xml.name = res.data.name
                    xml.scenario = res.data.scenario
                    xml.scenarioResult = res.data.scenarioResult
                    
                    this.$store.commit("setXML", xml);
                    localStorage.setItem("xml", JSON.stringify(xml));
                  })
                  .catch(console.log);
              } catch (error) {
                showError(this.$t('problema-ao-carregar-o-modelo-ativo'));
              }
            }

            Object.assign(goalSeek)
            goalSeek.callFromGoalSeek = true
            goalSeek.scenario = JSON.parse(localStorage.getItem("xml")).scenario;
            goalSeek.scenarioResult = JSON.parse(localStorage.getItem("xml")).scenarioResult;
            goalSeek.manipulatedVariableMapping = this.goalSeekModel.manipulatedVariableMapping;
            goalSeek.processVariableMapping = this.goalSeekModel.processVariableMapping;
            goalSeek.objective = parseFloat(this.goalSeekModel.objective);
            goalSeek.maxIteractions = parseFloat(this.goalSeekModel.maxIteractions);
            goalSeek.initialValue = parseFloat(this.goalSeekModel.initialValue);
            goalSeek.tolerance = parseFloat(this.goalSeekModel.tolerance / 100);
            goalSeek.secondaryValue = parseFloat(this.goalSeekModel.secondaryValue ? this.goalSeekModel.secondaryValue : 0);
            goalSeek.sucessiveSubstitution = this.goalSeekModel.sucessiveSubstitution;
            goalSeek.x = [0, 0, 0];
            let el = document.querySelector(".msg");
            if(el)
              el.innerHTML = "";
            this.setStopSimulation.refreshToken();
            console.log('this.setStopSimulation :>> ', this.setStopSimulation);
            defaultSuccess(this.$t('iniciando-simulacao'));
            this.stateOfSimulation(true)
            
            await axios.post(`${urlMainAPI}/executeproductionplansimulation`, goalSeek, { cancelToken: this.setStopSimulation.executeRequest.token})
              .then(d => d.data)
              .then(data => this.findSolution(data))
              .catch(e => {
                console.log("DoGoalSeek ->" + e)
                this.blockFilds(false);
                this.stateOfSimulation(false)
              })
          },



          // Atualiza o Box
          findSolution: async function (data) {
            // Verificando se foi encontrado solução para o objetivo
            console.log("Verificando resultados", data)
            document.querySelector(".msg").innerHTML = ""
            data.message.forEach(msg => {
              let element = document.createElement("p")
              element.style.margin = "0"
              element.innerHTML = msg
              document.querySelector(".msg").append(element)
            });
            this.setStopSimulation.refreshToken();
        
            if (data.status === 1) {
              this.blockFilds(false);
              
              defaultSuccess(this.$t('solucao-encontrada-erro') + `${data.error.toFixed(2).replace(".", ",")}`);
              this.sucessSimulation.info = this.$t('a-solucao-foi-encontrada-x') + ` ${data.step.toFixed(2)} `+ this.$t('em') + `${data.iteraction}` + this.$t('interacoes');
              this.sucessSimulation.question = this.$t('deseja-substituir-os-dados-no-diagrama') 
              this.goalSeekModel = data;
              this.stateOfSimulation(false)

              this.openMessage();
              return data;
            }
            else if (data.status === -1) {
              console.log("Solução Não encontrada: ")
              data.message.forEach(console.log)
              this.blockFilds(false);
              showError(this.$t('nao-foi-possivel-encontrar-uma-solucao'))
              this.stateOfSimulation(false)
              return data;
            }
            else {
              console.log(`Erro: ${data.error.toFixed(2).replace(".", ",")} recalculando...`)
              this.blockFilds(true);

              await axios.post(`${urlMainAPI}/dogoalseek`, data, { cancelToken: this.setStopSimulation.executeRequest.token})
                .then(d => {
                  this.findSolution(d.data)
                })
                .catch(e => {
                  this.blockFilds(false);
                  console.log("Solução Não encontrada:", e)
                  return data;
                })
            }
          },


          // Abre a caixa de mensagem de sucesso
          openMessage() {
              document.querySelector('.msgBox').style.display = 'flex'
          },          


          // Aplica as configurações após ter encontrado a solução do Atingir metas
          applyDiagram: async function () {
            document.querySelector('.msgBox').style.display = "none";
            this.msgLoading = "Carregando..."
            this.blockFilds(true);

            let obj = {
              scenario: this.goalSeekModel.scenario,
              scenarioResult: this.goalSeekModel.scenarioResult,
              table: this.table,
              tableResult: this.tableResultGoal,
              inputMapping: null
            }
            this.callCalculationSimulation(obj, this.showLoading)

            this.$bvModal.hide(this.nameModel);

            this.blockFilds(false);
          },



          //Manipula checkbox com o valor secundário
          enableSecondaryValue() {
            if(!this.checked){
              document.querySelector('#secondaryValue').setAttribute("disabled", "disabled")
            }else{
              document.querySelector('#secondaryValue').removeAttribute("disabled")
            }
          },



          //Bloqueia Campos enquanto simula
          blockFilds: (stop) => {
            if (stop) {
              document.querySelectorAll("input").forEach(e => e.setAttribute("disabled", "disabled"))
              document.querySelectorAll("select").forEach(e => e.setAttribute("disabled", "disabled"))
              document.querySelector('#simulate').style.display = "none";
              document.querySelector('#stopSimulatorImage').style.display = "flex";
              document.querySelector('.loading').style.display = 'flex';
            } else {
              document.querySelectorAll("input").forEach(e => e.removeAttribute("disabled", "disabled"))
              document.querySelectorAll("select").forEach(e => e.removeAttribute("disabled", "disabled"))
              document.querySelector('#simulate').style.display = "block";
              document.querySelector('#stopSimulatorImage').style.display = "none";
              document.querySelector('.loading').style.display = 'none';
              document.querySelector("#sucessiveSubstitution").checked ? document.querySelector('#secondaryValue').setAttribute("disabled", "disabled") : document.querySelector('#secondaryValue').removeAttribute("disabled")
            }
          }
        },
        created() {
          //Carrega seletores de variáveis objetivo e simulada
          axios.get(`${urlMainAPI}/getmaneuvervariable`).then(d => d.data)
            .then( maneuver => this.maneuverVariables = maneuver);
          axios.get(`${urlMainAPI}/getprocessvariable`).then(d => d.data)
            .then(process => this.processVariables = process);
        },
        destroyed() {
          this.blockFilds(false)
          if (this.stateOfSimulation('state')){
            this.setStopSimulation.stopStimulation()
            this.stopStimulation.refreshToken()
            this.stateOfSimulation(false)
          }
        },
  }
</script>

<style scoped>

div {
  display: flex;
  flex-direction: column;
  align-items: top;
  justify-content: center;
  border: 1px solid rgba(72, 69, 87, 0.212);
  padding: 5px 5px;
  border-radius: 4px;
}

.container {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 260px 170px 40px;
  gap: 10px;
  width: 100%;
  max-width: 1000px;
  padding: 0;
  margin: -5px;
}

.containter>div {
  border-bottom: 1px solid #ccc;
}

.head h1{
  font-size: 1.1em;
  display: flex;
  padding: 5px 10px;
  margin: 0;
}

.container h2 {
  font-size: 1.05em;
  float: left;
  margin: 0;
}

.box {
  grid-row-start: 1;
  display: block;
}

.loading{
  border: none;
  display: none;
}

.box label, .box2 label,.box3 label {
  float: left;
}

.box select{
  float: left;
  margin: 2px 5px;
  width: 95%;
  height: 26px;
}

.box input {
  margin: 1px 5px;
  float: right;
  width: 130px;
}

.box2 {
  text-align: left;
  justify-content: space-between;
  grid-row-start: 1;
  grid-column-start: 2;
}


.box2 input, .box2 label {
  margin-bottom: 4px;
}


.box2 input {
  float: right;
}

.box2 input:focus{
  outline: 0;
  border-radius: 2px;
  border: 2px solid rgb(103, 163, 216);
  box-shadow: 0 1px 3px rgb(103, 163, 216);
}

.box2 input:nth-child(1){
  float: left;
  margin: 6px 10px;
}

.box3 {
  grid-row-start: 2;
  justify-content: start;
  text-align: left;
  grid-column-end: span 2;
  align-self: start;
  height: 170px;
}

.box3>div {
  border: none;
}

.msg {
  margin-top: 2px;
  justify-content: start;
  overflow: hidden;
  overflow-y: scroll;
}

.msg::-webkit-scrollbar{
  display: none;
}

footer{
  grid-row-start: 3;
  grid-column-start: 2;
}

footer>p{
  grid-row-start: 3;
  grid-column-start: 1;
  float: left;
}

footer>img{
  float: right;
  margin-right: 20px;
  cursor: pointer;
  max-height: 35px;
  max-width: 35px;
}

footer>img#loadingEntries{
  cursor: default;
}

#stopSimulatorImage{
  display: none;
  max-height: 35px;
  border-radius: 7px;
  padding: 3px;
  align-self: flex-start;
}

.msgBox{
  top: calc(50% - 210px )
}

@media (max-width: 990px) { 
    .container {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 215px 270px 1fr 40px;
    width: 100%;
    height: 100%;
    min-width: 370px;
  }
  .box {
    grid-row-start: 1;
  }
  .box2 {
    grid-row-start: 2;
    grid-column-start: 1;
  }
  .box3 {
    grid-row-start: 3;
  }

  footer{
    grid-row-start: 4;
    grid-column-start: 1;
  }

}

@media (max-width: 360px) { 
    .container {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 230px 520px 1fr 40px;
    width: 100%;
    height: 100%;
    min-width: 310px;
  }

  .box {
    grid-row-start: 1;
  }


  .box2 {
    grid-row-start: 2;
    grid-column-start: 1;
  }

  .box {
    justify-content: space-between;
  }

  .box>select {
    margin: 0 10px;
  }
  .box2>span {
    display: flex;
    flex-direction: column;
  }

  .box2>span:last-child {
    flex-direction: row;
  }

  .box2>span>input {
    margin: 3px;
  }

  .box3 {
    grid-row-start: 3;
  }

  footer{
    grid-row-start: 4;
    grid-column-start: 1;
  }

}
</style>